import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import React, { useState } from 'react';
import { Button } from 'primereact/button';

interface AddListAttributeDialogDatamodel {
  onAttributeSave: (str: string) => any;
}
export const AddListAttributeDialog: React.FC<
  AddListAttributeDialogDatamodel
> = ({ onAttributeSave }) => {
  const [attributeListItem, setAttributeListItem] = useState('');
  return (
    <div>
      <EditText value={attributeListItem} onChange={setAttributeListItem} />

      <div
        style={{ height: '30px', display: 'flex', justifyContent: 'center' }}
      >
        <Button
          onClick={() => onAttributeSave(attributeListItem)}
          label={'שמירה'}
        />
      </div>
    </div>
  );
};
